var exports = {
  "FS": "searchSlot__PLyIP2",
  "hZ": "trigger__A07fH5",
  "Qs": "content__-QV4lC",
  "Kk": "icon__dKfd-T",
  "Pf": "label__Axw9pp",
  "eS": "kbd__-xAXYz",
};

module.exports = exports;
